import React, { useRef } from "react"
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    Filler,
} from "chart.js"
import { Bar } from "react-chartjs-2"
import { _DeepPartialObject } from "chart.js/dist/types/utils"
import { ChartJSOrUndefined } from "react-chartjs-2/dist/types"
import { ResponseDatiNazionaliMultiAnno } from "@/utility/model"

Filler.beforeDraw = function (c, a, b) {
    var ctx = c.ctx
    ctx.fillStyle = "white"
    ctx.fillRect(0, 0, c.width, c.height)
    return true
}

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    Filler
)

interface BarChartProps {
    data: ResponseDatiNazionaliMultiAnno[]
    title: string
    anno: number
    dataKey: keyof ResponseDatiNazionaliMultiAnno
}

function roundTicks(
    value: number,
    dataKey: keyof ResponseDatiNazionaliMultiAnno
) {
    if (dataKey == "punteggioIsa") {
        return 1
    }
    
    let numStr = [...value.toString()];

    if (Number(numStr[1]) < 5) {
        numStr[1] = "5"
    } else {
        numStr[1] = "0"
        numStr[0] = (Number(numStr[0]) + 1).toString();
    }

    for (let i = 2; i < numStr.length; i++) {
        if (numStr[i] != ".")
            numStr[i] = "0"
    }

    return Number(numStr.join("")) / 10
}

export default function ChartNazionaliMultiAnno({
    data,
    title,
    anno,
    dataKey
}: BarChartProps) {
    var distinctArr: { values: number[]; label: string }[] = []

   distinctArr = data.map((e) => ({
        label: e.anno,
        values: data
            .filter((f) => f.anno == e.anno)
            .map((m:any) => Number(m[dataKey].replaceAll(".","").replaceAll(",",".")))
    }))

    const options = {
        indexAxis: "x" as const,
        //fullWidth:true,

        elements: {
            bar: {
                borderWidth: 1,
                padding: 10
            }
        },
        scales: {
            x: {
                ticks: {
                    font: { size: 14 }
                }
            },
            y: {
                ticks: {
                    stepSize: roundTicks(
                        Math.max(...distinctArr.flatMap((e) => e.values)),
                        dataKey
                    )
                },
                suggestedMax: dataKey == "punteggioIsa" ? 10 : undefined
            }
        },
        responsive: false,
        //grouped: true,
        plugins: {
            legend: {
                position: "bottom" as const,
                display:false
            },
            title: {
                display: true,
                text: title,
                font: { size: 18 }
            }
        }
    }
    const datasets = {
        labels: distinctArr.map(({ label }) => label),

        datasets: [
            {
                label: title,
                data: distinctArr.flatMap((e) => e.values),
                backgroundColor: ["#00008B", "#008000", "#FF0000"],
                barThickness: 45,
                borderRadius: 15
            }
        ]
    }

    const chartRef = useRef<ChartJSOrUndefined<"bar", number[], string>>(null)

    return (
        <div >
            <Bar
                ref={chartRef}
                className="NazionaliChart_ChartJs"
                options={options}
                data={datasets}
                width={700}
                height={400}
                style={{marginRight:0,marginInline:'auto'}}
            />
        </div>
    )
}
